"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CreditCards.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CreditCards = function CreditCards(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 205.51 174.71"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "line-icon-credit-cards"), _react2.default.createElement("path", {
    className: "credit-card",
    d: "M204.69 96.59L158.9 4.37A7.89 7.89 0 0 0 148.34.82L37.55 56H8.65A8.66 8.66 0 0 0 0 64.64v101.42a8.66 8.66 0 0 0 8.65 8.65h158.24a8.66 8.66 0 0 0 8.65-8.65v-46.22l25.6-12.69a7.89 7.89 0 0 0 3.55-10.56zM8.65 63h158.24a1.67 1.67 0 0 1 1.65 1.65v49.14H7V64.64A1.67 1.67 0 0 1 8.65 63zM7 120.79h161.54v20.52H7v-20.52zm159.89 46.92H8.65A1.67 1.67 0 0 1 7 166.06v-17.75h161.54v17.75a1.67 1.67 0 0 1-1.65 1.65zm31.57-67.33a.87.87 0 0 1-.43.5L175.54 112V64.64a8.66 8.66 0 0 0-8.65-8.64H53.25l98.2-48.9a.89.89 0 0 1 1.17.39l45.79 92.22a.87.87 0 0 1 .05.66z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CreditCards;